module.exports = "<div class = 'topNav'>\n  <h1>{{title}}</h1>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/top-nav/top-nav.component.html
// module id = 159
// module chunks = 1